"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AbstractProcessor {
    decodeError(responseData) {
        return {
            status: (responseData.code || responseData.status),
            message: ((!!responseData.details && responseData.details.message) || responseData.message)
        };
    }
}
exports.AbstractProcessor = AbstractProcessor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWJzdHJhY3QucHJvY2Vzc29yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb2Nlc3NvcnMvYWJzdHJhY3QucHJvY2Vzc29yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBc0IsaUJBQWlCO0lBSTlCLFdBQVcsQ0FBQyxZQUFZO1FBQzdCLE9BQU87WUFDTCxNQUFNLEVBQUUsQ0FBQyxZQUFZLENBQUMsSUFBSSxJQUFJLFlBQVksQ0FBQyxNQUFNLENBQUM7WUFDbEQsT0FBTyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDLE9BQU8sSUFBSSxZQUFZLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLFlBQVksQ0FBQyxPQUFPLENBQUM7U0FDNUYsQ0FBQztJQUNKLENBQUM7Q0FFRjtBQVhELDhDQVdDIn0=